import { combineReducers } from 'redux';
import storage from 'redux-persist/lib/storage';
import { notificationApi } from '@ports/internal-services/notification/notificationApi';
import { countryApi } from '@ports/internal-services/country/countryApi';
import { fileExportApi } from '@ports/internal-services/fileExport/fileExportApi';
import { stateApi } from '@ports/internal-services/state/stateApi';
import { zipCodeApi } from '@ports/internal-services/zipCodes/zipCodeApi';
import { userApi } from '@ports/internal-services/user/userApi';
import { scheduleApi } from '@ports/internal-services/schedule/scheduleApi';
import { localareaApi } from '@ports/internal-services/localarea/localareaApi';
import { faqApi } from '@ports/internal-services/faq/faqApi';
import { downloadCenterApi } from '@ports/internal-services/downloadCenter/downloadCenterApi';
import { mealRequestApi } from '@ports/internal-services/mealRequest/mealRequestApi';
import { resourceApi } from '@ports/internal-services/resource/resourceApi';
import { manualMatchingApi } from '@ports/internal-services/manualMatching/manualMatchingApi';
import { insightsDashboardApi } from '@ports/internal-services/insightsDashboard/insightsDashboardApi';
import { userDetailsApi } from '@ports/internal-services/userDetails/userDetailsApi';
import { contactListApi } from '@ports/internal-services/contactList/contactListApi';
import { settingsApi } from '@ports/internal-services/settings/settingsApi';
import { captchaApi } from '@ports/internal-services/captcha/captchaApi';
import { groupsApi } from '@ports/internal-services/groups/groupsApi';
import { userRoleRequestApi } from '@ports/internal-services/userRoleRequest/userRoleRequestApi';
import { eventLasagnaApi } from '@ports/internal-services/eventLasagna/eventLasagnaApi';
import { utilizationApi } from '@ports/internal-services/utilization/utilizationApi';
import { homeApi } from '@ports/internal-services/home/homeApi';
import { authApi } from '../internal-services/auth/authApi';
import { sessionStateSlice } from './sessionStateSlice';
import { alertSlice } from './alertStateSlice';
import { appLoadingStateSlice } from './appLoadingStateSlice';
import { manualLoadingStateSlice } from './manualLoadingStateSlice';
import { countryStateSlice } from './countryDetailsSlice';
import { authStateSlice } from './authStateSlice';
import { stateStateSlice } from './stateDetailsSlice';
import { uploadProgressStateSlice } from './uploadProgressStateSlice';
import { userStateSlice } from './userStateSlice';
import { credentialsStateSlice } from './credentialStateSlice';
import { localareaDetailsSlice } from './localareaDetailsStateSlice';
import { sideBarStateSlice } from './sideBarStateSlice';
import { resendTimerStateSlice } from './resendTimerStateSlice';
import { volunteerStateSlice } from './volunteerStateSlice';
import { zipcodeStateSlice } from './zipcodeStateSlice';
import { scheduleStateSlice } from './scheduleStateSlice';
import { matchStateSlice } from './matchStateSlice';
import { roleFilterStateSlice } from './roleFilterStateSlice';
import { rolePermissionStateSlice } from './rolePermissionStateSlice';
import { groupsStateSlice } from './groupsStateSlice';

const rootPersistConfig = {
  key: 'root',
  storage,
  keyPrefix: 'redux-'
};

const rootReducer = combineReducers({
  [authApi.reducerPath]: authApi.reducer,
  [notificationApi.reducerPath]: notificationApi.reducer,
  [countryApi.reducerPath]: countryApi.reducer,
  [stateApi.reducerPath]: stateApi.reducer,
  [fileExportApi.reducerPath]: fileExportApi.reducer,
  [userApi.reducerPath]: userApi.reducer,
  [scheduleApi.reducerPath]: scheduleApi.reducer,
  [localareaApi.reducerPath]: localareaApi.reducer,
  [resourceApi.reducerPath]: resourceApi.reducer,
  [utilizationApi.reducerPath]: utilizationApi.reducer,
  [sessionStateSlice.name]: sessionStateSlice.reducer,
  [alertSlice.name]: alertSlice.reducer,
  [appLoadingStateSlice.name]: appLoadingStateSlice.reducer,
  [manualLoadingStateSlice.name]: manualLoadingStateSlice.reducer,
  [countryStateSlice.name]: countryStateSlice.reducer,
  [authStateSlice.name]: authStateSlice.reducer,
  [zipCodeApi.reducerPath]: zipCodeApi.reducer,
  [stateStateSlice.name]: stateStateSlice.reducer,
  [uploadProgressStateSlice.name]: uploadProgressStateSlice.reducer,
  [userStateSlice.name]: userStateSlice.reducer,
  [credentialsStateSlice.name]: credentialsStateSlice.reducer,
  [localareaDetailsSlice.name]: localareaDetailsSlice.reducer,
  [sideBarStateSlice.name]: sideBarStateSlice.reducer,
  [faqApi.reducerPath]: faqApi.reducer,
  [settingsApi.reducerPath]: settingsApi.reducer,
  [resendTimerStateSlice.name]: resendTimerStateSlice.reducer,
  [volunteerStateSlice.name]: volunteerStateSlice.reducer,
  [mealRequestApi.reducerPath]: mealRequestApi.reducer,
  [zipcodeStateSlice.name]: zipcodeStateSlice.reducer,
  [downloadCenterApi.reducerPath]: downloadCenterApi.reducer,
  [scheduleStateSlice.name]: scheduleStateSlice.reducer,
  [matchStateSlice.name]: matchStateSlice.reducer,
  [manualMatchingApi.reducerPath]: manualMatchingApi.reducer,
  [userDetailsApi.reducerPath]: userDetailsApi.reducer,
  [contactListApi.reducerPath]: contactListApi.reducer,
  [roleFilterStateSlice.name]: roleFilterStateSlice.reducer,
  [insightsDashboardApi.reducerPath]: insightsDashboardApi.reducer,
  [captchaApi.reducerPath]: captchaApi.reducer,
  [rolePermissionStateSlice.name]: rolePermissionStateSlice.reducer,
  [groupsApi.reducerPath]: groupsApi.reducer,
  [groupsStateSlice.name]: groupsStateSlice.reducer,
  [userRoleRequestApi.reducerPath]: userRoleRequestApi.reducer,
  [eventLasagnaApi.reducerPath]: eventLasagnaApi.reducer,
  [homeApi.reducerPath]: homeApi.reducer
});

export { rootPersistConfig, rootReducer };
